module.exports = __webpack_public_path__ + "static/media/chain_heal.eccc6a1c.png";